import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
registerModuleCatalog('payroll-agreement', (locale) => import(`./locales/${locale}.po`), {
  eager: true,
});
export const loadPayrollAgreementMessages = () => ensureModuleMessages('payroll-agreement');
